import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupMpaPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/mpa/points.hbs" })